import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../assets/css/categoryList.css';
import Breadcrumb from '../Component/Layout/Breadcrumb';
import SearchFilter from '../Component/Layout/Searchlist';
import MobileFilter from '../Component/Layout/MobileFilter/MobileFilter';
import ProductShorting from '../Component/Common/ProductShorting';
import Whatsappcatlog from '../Component/Media/Whatsappcatlog';

import p1 from '../../src/assets/images/img/hd-1.webp'
import p2 from '../../src/assets/images/img/hd-2.webp'
import p3 from '../../src/assets/images/img/hd-3.webp'
import p4 from '../../src/assets/images/img/hd-4.webp'
import p5 from '../../src/assets/images/img/hd-5.webp'
import p6 from '../../src/assets/images/img/hd-6.webp'
import p7 from '../../src/assets/images/img/hd-7.webp'

const Homedecor = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Simulate data fetching delay
    setTimeout(() => {
      const fetchedProducts = [
        { id: 1, name: 'Attractive Showpiece', image: p1 },
        { id: 2, name: 'Ceramic Vase', image: p2 },
        { id: 3, name: 'Elephant Showpiece', image: p3 },
        { id: 4, name: 'Horse Showpiece', image: p4 },
        { id: 5, name: 'Horse Showpiece', image: p5 },
        { id: 6, name: 'Owl Showpiece', image: p6 },
        { id: 7, name: 'Wooden Vase', image: p7 },
      ];
      setProducts(fetchedProducts);
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <Breadcrumb />
      <section className="category-List">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-6 col-12">
              {/* Header Row */}
              <div className="row DesktopScreen">
                <div className="col-md-2 col-4">
                  <div className="FILTER-MOBILE">
                    <MobileFilter />
                  </div>
                </div>
                <div className="col-md-4 col-5 text-end">
                  <p
                    style={{
                      textAlign: 'left',
                      color: 'rgb(127 127 127)',
                      marginBottom: 0,
                      marginTop: '2px',
                      fontSize: '14px',
                    }}
                   >
                    Showing {products.length} items
                  </p>
                </div>
                <div className="col-md-6 col-5">
                  <div className="d-Fles-Rto" style={{ justifyContent: 'flex-end' }}>
                    <SearchFilter />
                    <ProductShorting />
                  </div>
                </div>
              </div>

              {/* Product Grid */}

              <div className="row">
                {loading
                  ? Array.from({ length: 5 }).map((_, index) => (
                      <div key={index} className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <div className="border-1 p-0 mt-1">
                          <Skeleton height={200} style={{ borderRadius: '2px' }} />
                          <div className="text-center mt-2">
                            <Skeleton width="80%" />
                          </div>
                        </div>
                      </div>
                    ))
                  : products.map((product) => (
                    <div key={product.id} className="col-lg-3 col-md-3 col-sm-6 col-6">
                    <div className="latest-items latest-items2">
                      <div className="properties">
                        <div className="properties-card">
                          <div className="properties-img hover-wrapper">
                            <Link to="/ProductDetails" target="_blank">
                              <img
                                src={product.image}
                                alt={product.name}
                                style={{ borderRadius: '2px', width: '100%', transition: 'transform 0.3s ease' }}
                                className="hover-image"
                              />
                            </Link>
                            <div className="share-hover">
                              <Whatsappcatlog />
                            </div>
                          </div>
                          <div className="properties-caption properties-caption2">
                            <h3>
                              <Link to="/ProductDetails" target="_blank">
                                {product.name}
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    ))}
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};
export default Homedecor; 
